<template>
  <div>
    <form @submit.prevent="handleSubmit" data-test="form">
      <div class="flex justify-center px-5">
        <div class="export-board">
          <div class="bg-white rounded-lg p-5 sm:p-8">
            <div class="sm:flex sm:space-x-10 sm:justify-between sm:items-end mb-5">
            <h3 class="text-xl text-left font-black">下載資料</h3>
            <a href="https://taie.tbn.org.tw/policies" target="_black"><p class="underline text-left mt-2 sm:mt-0">使用條款及隱私權政策</p></a>
            </div>
            <p class="mb-3 text-lg text-left font-black">頁數範圍</p>
              <div class="space-y-3">
                <div>
                  <!-- 頁數範圍 -->
                  <input
                    type="text"
                    id=""
                    name=""
                    class="bg-gray-100 p-2 rounded-md w-full"
                    data-test="page-range"
                    placeholder="例如：6-8"
                    v-model="inputPageRange"
                    :onKeypress="inputPagesKeyPress"
                    :onKeyup="inputPagesKeyUp"
                    :onblur="inputPagesOnBlur"
                    required
                  />
                  <p id="idPageRange" class="input-warning" data-test="page-range-error" v-if="errors.pageRange">{{ errors.pageRange }}</p>
                </div>
              </div>
              <p class="my-3 text-lg text-left font-black">使用者資訊</p>
              <div class="space-y-3">
                <div>
                  <!-- 姓名 -->
                  <input
                    type="text"
                    id="name"
                    name="name"
                    class="bg-gray-100 p-2 rounded-md w-full"
                    data-test="name"
                    placeholder="姓名"
                    v-model="inputUserName"
                    :onblur="inputUserNameOnBlur"
                    required
                  />
                  <p id="idName" class="input-warning" v-if="errors.name">{{ errors.name }}</p>
                </div>
                <div>
                  <!-- 電子郵件 -->
                  <input
                    type="text"
                    id="email"
                    name="email"
                    class="bg-gray-100 p-2 rounded-md w-full"
                    data-test="email"
                    placeholder="電子郵件"
                    v-model="inputUserEmail"
                    :onKeyup="inputEmailKeyUp"
                    :onblur="inputEmailOnBlur"
                    required
                  />
                  <p id="idEmail" class="input-warning" data-test="email-error" v-if="errors.email">{{ errors.email }}></p>
                </div>
              </div>
            <div class="flex justify-center space-x-5 pt-5">
              <div @click="close" class="cancel-button cursor-pointer" data-test="cancel-button">取消</div>
              <!-- 送出按鈕 -->
              <button
                type="submit"
                class="submit-button"
                data-test="submit-button"
                :disabled="disableSubmit"
              >
                送出
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthMixins from '@/mixins/auth';
import Validate from "@/utils/validate";
import { downloadAndEmailSpecimenSearchResults } from "@/api/specimen";

export default {
  mixins: [AuthMixins],
  data() {
    return {
      inputPageRange: "",
      inputUserName: "",
      inputUserEmail: "",
      totalPages: 0,
      excelMaxItems: 1000,
      disableSubmit: true,
      queryFields: {},
      errors: {
        name: "",
        email: "",
        pageRange: ""
      }
    };
  },
  computed: {
    createDownloadExcelPattern() {
      var downloadFields = {}

      downloadFields = Object.assign({}, this.queryFields);
      downloadFields.name = this.inputUserName
      downloadFields.email = this.inputUserEmail
      downloadFields.export_page = this.inputPageRange

      return downloadFields
    },
  },
  mounted() {
    this.queryFields = this.$store.getters["search/queryFields"];
    this.totalPages = this.$store.state.search.totalPages;
  },
  methods: {
    inputPagesKeyPress($event) {
      // keyCodes value
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      // only allow number (48:0, 49:1, ..., 57:9) and one hyphen(45:-)
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 45)) {
        $event.preventDefault()
      }
    },
    setInputPagesWarning(value) {
      if (value === 0) {
        this.errors.pageRange = "此為必填欄位"
      } else if (value === 1) {
        this.errors.pageRange = ""
        this.disableSubmit = false
      } else if (value === 2) {
        this.errors.pageRange = "格式不符，只能包含數字和最多一個連接號(-)"
      } else if (value === 3) {
        this.errors.pageRange = "指定範圍內的總結果不得超過 " + this.excelMaxItems.toString() + " 筆"
      } else {
        this.errors.pageRange = "格式不符或超出範圍"
      }
    },
    inputPagesKeyUp ($event) {
      this.disableSubmit = true
      this.setInputPagesWarning(this.validatePageRange(this.inputPageRange))
    },
    inputPagesOnBlur() {
      this.disableSubmit = true
      this.setInputPagesWarning(this.validatePageRange(this.inputPageRange))
    },
    inputUserNameOnBlur() {
      this.errors.name = ""
      if (this.inputUserName.length === 0) {
        this.errors.name = "此為必填欄位";
      }
    },
    inputEmailOnBlur() {
      this.errors.email = ""
      if (this.inputUserEmail.length === 0) {
        this.errors.email = "此為必填欄位"
      }
    },
    inputEmailKeyUp($event) {
      this.errors.email = ""
      if (!Validate.validEmail(this.inputUserEmail)) {
        this.errors.email = "請輸入正確的電子郵件格式";
      }
    },
    validatePageRange(value) {
      if (value.length === 0) {
        return 0
      } else if (!value.match(/-/g)) {
        var integer = parseInt(value, 10)
        if ((integer < 1) || (integer > this.totalPages)) {
          return 4
        } else {
          return 1
        }
      } else if (value.match(/-/g).length !== 1) {
        return 2
      } else {
        const hyphenLocation = value.indexOf('-')
        const splitResult = value.split('-')
        var leftInteger = parseInt(splitResult[0], 10)
        var rightInteger = parseInt(splitResult[1], 10)
        if (hyphenLocation === 0 ||
            hyphenLocation === value.length - 1 ||
            leftInteger > rightInteger ||
            leftInteger === rightInteger ||
            leftInteger < 0 ||
            leftInteger > this.totalPages ||
            rightInteger > this.totalPages) {
          return 4
        } else if (((rightInteger - leftInteger + 1) * this.queryFields.pagesize) > this.excelMaxItems) {
          return 3
        } else {
          return 1
        }
      }
    },
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      if (this.inputPageRange.length === 0 ||
          this.inputUserName.length === 0 ||
          this.inputUserEmail.length === 0 ||
          this.validatePageRange(this.inputPageRange) !== 1 ||
          !Validate.validEmail(this.inputUserEmail)) {
        this.$notify({
          title: '注意',
          message: '請確認輸入格式是否正確',
          type: 'warning',
          duration: 2000
        })
      } else {
        downloadAndEmailSpecimenSearchResults(this.createDownloadExcelPattern, this.loggedIn).then(resp => {
          this.$notify({
            title: '成功',
            message: '資料下載成功',
            type: 'success',
            duration: 2000
          })
        }).catch(resp => {
          // console.log('Download Specimen Image failed')
          this.$notify({
            title: '失敗',
            message: '資料下載失敗',
            type: 'error',
            duration: 2000
          })
        })
      }

      this.$emit("close");
    },
  }
}

</script>

<style scoped>
.export-board {
  width: 500px;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.web-disabled-bg-color {
  background-color: #869fb1;
}

.web-bg-color {
  background-color: #64859D;
}

.web-dark-bg-color {
  background-color: #405d73;
}

.text-warning {
  margin-left: 10px;
}

.input-warning {
  @apply text-warning text-red-500 text-left;
}

.submit-button {
  @apply web-bg-color rounded px-5 py-2 text-white;
}

.submit-button:hover {
  @apply web-dark-bg-color rounded px-5 py-2 text-white;
}

.submit-button:disabled {
  @apply web-disabled-bg-color rounded px-5 py-2 cursor-not-allowed;
}

.cancel-button {
  @apply bg-gray-300 rounded px-5 py-2;
}

.cancel-button:hover {
  @apply bg-gray-400 rounded px-5 py-2;
}

.exportDialog-over-line {
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
